import { useAuth } from "../components/AuthProvider";
import { useWalletAddress } from "./useWalletAddress";

function useActiveConnector() {
  const { metaMask, coinBase, walletConnect } = useAuth();
  const address = useWalletAddress();

  if (!address) return undefined;

  const active = [metaMask, coinBase, walletConnect].find(({ state }) =>
    state.accounts?.includes(address)
  )?.connector;

  return active;
}

export { useActiveConnector };
